import { createPermissionChecker, PORTFOLIO_PERMISSIONS, QUEXT_PERMISSIONS } from '@/components/auth/permissions';

export default [
    {
        path: '/customers',
        name: 'customers.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/CustomersList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'customers',
            title: 'customers',
            flowStartsWith: 'customers.index',
            product: 'qxt-admin',
            permissionChecker: createPermissionChecker(QUEXT_PERMISSIONS.VIEW_CUSTOMERS),
        },
    },
    {
        path: '/customers/create',
        name: 'customers.create',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/CustomersCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new customer',
            flowStartsWith: 'customers.index',
            product: 'qxt-admin',
            permissionChecker: createPermissionChecker(QUEXT_PERMISSIONS.ADD_CUSTOMER),
        },
    },
    {
        path: '/customers/:customerId/details',
        name: 'customers.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/CustomerDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'customer details',
            flowStartsWith: 'customers.index',
            title: 'view customer',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_DETAILS),
        },
    },
    // Communities
    {
        path: '/customers/:customerId/communities',
        name: 'customer.communities.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunitiesList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'communities',
            title: 'manage company communities',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.communities.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_COMMUNITIES),
        },
    },
    {
        path: '/customers/:customerId/communities/import',
        name: 'customer.communities.import',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunitiesImportView'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'import communities',
            title: 'import communities',
            flowStartsWith: 'customer.communities.index',
            passFlowTo: 'customer.communities.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(QUEXT_PERMISSIONS.IMPORT_COMMUNITIES),
        },
    },
    {
        path: '/customers/:customerId/communities/create',
        name: 'customer.communities.create',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunitiesCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new community',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.communities.create',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(QUEXT_PERMISSIONS.ADD_COMMUNITY),
        },
    },
    {
        path: '/customers/:customerId/communities/:communityId/details',
        name: 'customer.communities.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunityDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'community details',
            title: 'community details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_COMMUNITY_DETAILS),
        },
    },
    {
        path: '/customers/:customerId/communities/:communityId',
        name: 'customer.communities.edit',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunitiesEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'community details',
            title: 'community details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(QUEXT_PERMISSIONS.EDIT_COMMUNITY),
        },
    },
    // Deleted communities
    {
        path: '/customers/:customerId/deleted-communities',
        name: 'customer.deletedCommunities.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/deletedCommunities/DeletedCommunitiesList'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'archived communities',
            breadcrumbName: 'archived communities',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_DELETED_COMMUNITIES),
        },
    },
    {
        path: '/customers/:customerId/deleted-communities/:communityId/details',
        name: 'customer.deletedCommunities.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunityDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'archived community details',
            breadcrumbName: 'archived community details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_DELETED_COMMUNITIES),
        },
    },
    // Users
    {
        path: '/customers/:customerId/users',
        name: 'customer.users.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UsersList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'users',
            title: 'manage company users',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.users.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_USERS),
        },
    },
    {
        path: '/customers/:customerId/users/create',
        name: 'customer.users.create',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UsersCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new company user',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.users.create',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.ADD_CUSTOMER_USER),
        },
    },
    {
        name: 'customer.users.create.permissions',
        path: '/customers/:customerId/users/permissions',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UserCustomPermissions'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'customize permissions',
            title: 'custom permissions',
            flowStartsWith: 'customer.users.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.ADD_CUSTOMER_USER),
        },
    },
    {
        path: '/customers/:customerId/users/:profileId/reinvite',
        name: 'customer.users.invite.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UserReinviteView'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 're-invite',
            title: 'resend invitation',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.REINVITE_CUSTOMER_USER),
        },
    },
    {
        name: 'customer.users.edit.permissions',
        path: '/customers/:customerId/users/:profileId/permissions',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UserCustomPermissions'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'customize permissions',
            title: 'custom permissions',
            flowStartsWith: 'customer.users.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.EDIT_CUSTOMER_USER),
        },
    },
    {
        path: '/customers/:customerId/users/:profileId',
        name: 'customer.users.edit',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UsersEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'edit',
            title: 'edit user',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.EDIT_CUSTOMER_USER),
        },
    },
    {
        path: '/customers/:customerId/users/:profileId/details',
        name: 'customer.users.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'user details',
            breadcrumbName: 'user details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_USER_DETAILS),
        },
    },
    // Deleted users
    {
        path: '/customers/:customerId/deleted-users',
        name: 'customer.deletedUsers.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/deletedUsers/DeletedUsersList'),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'company deleted users',
            breadcrumbName: 'deleted users',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_DELETED_CUSTOMER_USERS),
        },
    },
    {
        path: '/customers/:customerId/deleted-users/:profileId/details',
        name: 'customer.deletedUsers.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'deleted user details',
            breadcrumbName: 'deleted user details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_DELETED_CUSTOMER_USERS),
        },
    },
    // Admins
    {
        path: '/customers/:customerId/admins',
        name: 'customer.admins.index',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'portfolio admins',
            title: 'manage portfolio admins',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.admins.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_PORTFOLIO_ADMINS),
        },
    },
    {
        path: '/customers/:customerId/admins/create',
        name: 'customer.admins.create',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new portfolio admin',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.admins.create',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.ADD_PORTFOLIO_ADMIN),
        },
    },
    {
        path: '/customers/:customerId/admins/:profileId/reinvite',
        name: 'customer.admins.invite.index',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminReinviteView'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 're-invite',
            title: 'resend invitation',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.REINVITE_CUSTOMER_USER),
        },
    },
    {
        path: '/customers/:customerId/admins/:profileId',
        name: 'customer.admins.edit',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'edit',
            title: 'edit portfolio admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.EDIT_PORTFOLIO_ADMIN),
        },
    },
    {
        path: '/customers/:customerId/admins/:profileId/details',
        name: 'customer.admins.details',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'admin details',
            title: 'admin details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_PORTFOLIO_ADMIN_DETAILS),
        },
    },
    {
        path: '/customers/:customerId/deleted-admins',
        name: 'customer.deletedAdmins.index',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/DeletedPortfolioAdminsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted admins',
            title: 'portfolio deleted admins',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.admins.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_PORTFOLIO_ADMINS),
        },
    },
    {
        path: '/customers/:customerId/deleted-admins/:profileId/details',
        name: 'customer.deletedAdmins.details',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'admin details',
            title: 'deleted admin details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_PORTFOLIO_ADMIN_DETAILS),
        },
    },
    // Roles
    {
        path: '/customers/:customerId/roles',
        name: 'customer.roles.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/roles/RolesList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'roles',
            title: 'manage company roles',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.roles.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_ROLES),
        },
    },
    {
        path: '/customers/:customerId/roles/:roleId/details',
        name: 'customer.roles.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/roles/RoleDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'role details',
            title: 'role details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_ROLES),
        },
    },
    // Deleted roles
    {
        path: '/customers/:customerId/deleted-roles',
        name: 'customer.deletedRoles.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/roles/DeletedRolesList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted roles',
            title: 'deleted company roles',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.roles.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_ROLES),
        },
    },
    {
        path: '/customers/:customerId/deleted-roles/:roleId/details',
        name: 'customer.deletedRoles.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/roles/RoleDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted role details',
            title: 'deleted role details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_ROLES),
        },
    },
    // Permissions
    {
        path: '/customers/:customerId/permissions',
        name: 'customer.permissions.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/permissions/PermissionsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'permissions',
            title: 'manage company permissions',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.permissions.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_PERMISSIONS),
        },
    },
    {
        path: '/customers/:customerId/deleted-permissions',
        name: 'customer.deletedPermissions.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/permissions/DeletedPermissionsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted permissions',
            title: 'deleted company permissions',
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.permissions.index',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_PERMISSIONS),
        },
    },

    // Deleted customers
    {
        path: '/deleted-customers/:customerId/details',
        name: 'deletedCustomers.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/CustomerDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'deleted customer details',
            breadcrumbName: 'deleted customer details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(QUEXT_PERMISSIONS.VIEW_DELETED_CUSTOMERS),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
    {
        path: '/deleted-customers/:customerId/communities',
        name: 'deletedCustomer.communities.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunitiesList'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'communities',
            title: 'view company communities',
            flowStartsWith: 'customers.index',
            passFlowTo: 'deletedCustomer.communities.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_COMMUNITIES),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
    {
        path: '/deleted-customers/:customerId/communities/:communityId/details',
        name: 'deletedCustomer.communities.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/communities/CommunityDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'community details',
            title: 'community details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_COMMUNITY_DETAILS),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
    {
        path: '/deleted-customers/:customerId/users',
        name: 'deletedCustomer.users.index',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UsersList'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'users',
            title: 'view company users',
            flowStartsWith: 'customers.index',
            passFlowTo: 'deletedCustomer.users.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_USERS),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
    {
        path: '/deleted-customers/:customerId/users/:profileId/details',
        name: 'deletedCustomer.users.details',
        component: () => import(/* webpackChunkName: "qxtsetup" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'user details',
            breadcrumbName: 'user details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_CUSTOMER_USER_DETAILS),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
    {
        path: '/deleted-customers/:customerId/admins',
        name: 'deletedCustomer.admins.index',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminsList'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'portfolio admins',
            title: 'view portfolio admins',
            flowStartsWith: 'customers.index',
            passFlowTo: 'deletedCustomer.admins.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_PORTFOLIO_ADMINS),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
    {
        path: '/deleted-customers/:customerId/admins/:profileId/details',
        name: 'deletedCustomer.admins.details',
        component: () => import(/* webpackChunkName: "padmin" */ '@/views/auth/customers/portfolioAdmins/PortfolioAdminDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            breadcrumbName: 'admin details',
            title: 'admin details',
            hideFromSearch: true,
            permissionChecker: createPermissionChecker(PORTFOLIO_PERMISSIONS.VIEW_PORTFOLIO_ADMIN_DETAILS),
            // custom props for this view only
            deactivatedCustomer: true,
        },
    },
];
